export default "__VITE_ASSET__c90fb3c9__"